import Scene from '../components/Scene'
import Header from '../components/Header'
import Footer from '../components/Footer'

import { SplashScreen, CrayolaLogo, PlayButton, Chevron } from './styles'

import playBtnSrc from '../assets/PlayButton.png'
import crayolaLogoSrc from '../assets/CrayolaLogo.png'
import rightChevronSrc from '../assets/right_chevron.png'
import leftChevronSrc from '../assets/left_chevron.png'

import useCameraPermimssion from '../config/hooks/useCameraPermimssion'
import Analytics from '../config/analytics'

/**
 * App entry point
 */
const App = () => {
  const { granted, zapparPermissionRequest } = useCameraPermimssion()

  const handlePermission = () => {
    Analytics.event.launch_button()
    zapparPermissionRequest()
  }

  const handleWithoutCookies = () => {
    Analytics.off()
    handlePermission()
  }

  /**
   * Start AR experience
   */
  if (granted) return <Scene />

  /**
   * Splash Screen
   */
  return (
    <SplashScreen>
      <Header />

      {/** Main Crayola logo */}
      <div className="flex-item-1 noselectimg">
        <CrayolaLogo src={crayolaLogoSrc} loading="eager" />
      </div>

      {/** Start button */}
      <div className="flex-item-2">
        <div id="launch-container" onClick={handlePermission}>
          <PlayButton
            src={playBtnSrc}
            className="noselectimg"
            draggable="false"
            loading="eager"
          />
        </div>
      </div>

      {/** Bottom chevron assets */}
      <Chevron src={leftChevronSrc} className="noselectimg" loading="eager" />
      <Chevron
        src={rightChevronSrc}
        className="noselectimg"
        loading="eager"
        right
      />

      <Footer launch={handleWithoutCookies} />
    </SplashScreen>
  )
}
export default App
